var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumaFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 32,
    viewBox: "0 0 110 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2676,
    y: 14.5305,
    width: 11.2329,
    height: 3.7961,
    fill: "#B246FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5496 4.36143C13.8705 2.70849 7.6775 5.39263 5.09814 10.9144C2.51877 16.4362 4.43722 22.9028 9.35286 26.1903L15.2227 13.6244L19.5496 4.36143Z",
    fill: "url(#paint0_linear_623_5196)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7575 5.80971C27.6731 9.09723 29.5916 15.5638 27.0122 21.0856C24.4328 26.6074 18.2399 29.2915 12.5607 27.6386L18.4305 15.0727L22.7575 5.80971Z",
    fill: "url(#paint1_linear_623_5196)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7981 25.4777C60.3692 25.4777 59.5535 25.2253 58.4321 24.7205C57.525 24.0848 56.7984 23.3475 56.2879 22.5842C55.673 21.6648 55.3655 20.1522 55.3655 19.4474V13.0366L59.8974 12.2276V19.3662C59.8974 19.8245 60.0602 20.3832 60.3858 20.7257C60.7294 21.0502 61.3741 21.2592 61.8806 21.2592C62.3689 21.2592 63.042 21.0502 63.3495 20.7257C63.675 20.3832 63.8378 19.9064 63.8378 19.3662V12.4754L68.3437 11.6438V19.4474C68.3437 20.398 68.0362 21.6918 67.4213 22.6112C66.8244 23.5126 66.1974 24.2157 65.1122 24.7205C64.027 25.2253 63.2088 25.4777 61.7981 25.4777Z",
    fill: "#423B46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.085 11.386C78.5138 11.386 79.1652 11.6383 80.2866 12.1431C81.1938 12.7788 81.9203 13.5161 82.4308 14.2794C83.0458 15.1988 83.3533 16.7114 83.3533 17.4162L83.3533 25.1501L78.8213 25.1501L78.8213 17.4974C78.8213 16.9025 78.6585 16.4337 78.333 16.0912C77.9893 15.7667 77.5643 15.6045 77.0578 15.6045C76.5695 15.6045 76.1716 15.7667 75.8641 16.0912C75.5386 16.4337 75.3758 16.9025 75.3758 17.4974L75.3758 25.1501L70.8698 25.1501L70.8698 17.4162C70.8698 16.4656 71.1773 15.1718 71.7923 14.2524C72.3891 13.351 73.0162 12.6479 74.1014 12.1431C75.1866 11.6383 75.6742 11.386 77.085 11.386Z",
    fill: "#423B46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3325 11.386C86.7614 11.386 87.4128 11.6383 88.5342 12.1431C89.4413 12.7788 90.1679 13.5161 90.6784 14.2794C91.2934 15.1988 91.6008 16.7114 91.6008 17.4162L91.6008 25.1501L87.0689 25.1501L87.0689 17.4974C87.0689 16.9025 86.9061 16.4337 86.5805 16.0912C86.2369 15.7667 85.8118 15.6045 85.3054 15.6045C84.8171 15.6045 84.4191 15.7667 84.1117 16.0912C83.7861 16.4337 83.6233 16.9025 83.6233 17.4974L83.6233 25.1501L79.1174 25.1501L79.1174 17.4162C79.1174 16.4656 79.4249 15.1718 80.0398 14.2524C80.6367 13.351 81.2638 12.6479 82.349 12.1431C83.4342 11.6383 83.9218 11.386 85.3325 11.386Z",
    fill: "#423B46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.158 23.6244C103.96 24.5863 102.435 25.1624 100.774 25.1624C96.9206 25.1624 93.7964 22.0586 93.7964 18.23C93.7964 14.4013 96.9206 11.2976 100.774 11.2976C102.452 11.2976 103.991 11.8856 105.195 12.8655L109.116 12.1393V25.1622H105.158V23.6244ZM104.022 18.2796C104.022 20.0443 102.582 21.4748 100.806 21.4748C99.0298 21.4748 97.5898 20.0443 97.5898 18.2796C97.5898 16.5149 99.0298 15.0843 100.806 15.0843C102.582 15.0843 104.022 16.5149 104.022 18.2796Z",
    fill: "#423B46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9031,
    y: 6.63403,
    width: 4.94816,
    height: 18.5161,
    fill: "#423B46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4487,
    y: 6.63403,
    width: 4.94816,
    height: 18.5161,
    fill: "#423B46"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.1536,
    height: 3.60562,
    transform: "matrix(0.985002 -0.172546 0.174757 0.984612 38.6948 15.3645)",
    fill: "#423B46"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_5196",
    x1: 18.5668,
    y1: 6.46542,
    x2: -11.3801,
    y2: 2.80595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_5196",
    x1: 21.7747,
    y1: 7.9137,
    x2: 43.7938,
    y2: 28.5207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumaFull);
export default __webpack_public_path__ + "static/media/huma-full.06722432bdcedfd49f20dc0afdef3811.svg";
export { ForwardRef as ReactComponent };